import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ComplianceTab from './ComplianceTab';
import USAInteractiveMap from "./ComplianceMap";
import ComplianceDashboard from './ComplianceDashboard';
import { SET_SELECTED_SITE } from './complianceConstants';

const ComplianceInitialLoad = () => {
  const [activeTabVal, setActiveTab] = useState('map');
  const dispatch = useDispatch();
  const stateList = useSelector(
    (state) => state.ComplianceReducer.stateList
  );
  const selectedSiteFromStore = useSelector(
    (state) => state.ComplianceReducer.selectedSite
  );
  useEffect(() => {
    if (activeTabVal === 'map') {
      dispatch({ type: SET_SELECTED_SITE, payload: { selectedSite: null } });
    } else if (activeTabVal === 'dashboard' && stateList.length>0 && (!selectedSiteFromStore || !selectedSiteFromStore.name)) {
      const firstState = stateList[0];
      dispatch({ type: SET_SELECTED_SITE, payload: { selectedSite: { name: firstState } } });
    }
  }, [activeTabVal]);
  const handleSiteSelection = (site) => {
    dispatch({ type: SET_SELECTED_SITE, payload: { selectedSite: site } });
    setActiveTab('dashboard');
  }
  return (
    <>
      <ComplianceTab activeTabProp={activeTabVal} setActiveTab={setActiveTab} />
      {activeTabVal === 'dashboard' ? <ComplianceDashboard /> : <USAInteractiveMap onSiteSelection={handleSiteSelection} />}
    </>
  );
};

export default ComplianceInitialLoad;